<!-- 
defaultContent
http://localhost:8084/?id=314a559e3e8a400f8a8531d972c6657b&type=article

bs ?id=6fc6f50a3c5c47fdb088d9c17087dfe4&type=article
ja ?id=f34bc53af97647a1b14118ae94a522a2&type=article
 -->
<template>
<div>
  <!-- <top @envChange="envChange"/> -->
  <div class="innerwrap" id="main">
    <top @envChange="envChange" v-if="!showBsTop"/>
    <bstop :view="view" v-if="showBsTop"></bstop>
    <div class="article-cent panel Article" id="example">
      <div class="art-tit">
        <h3 id="ivs_title">
          {{view.title}}
        </h3>
        <div class="left-sp">
          <span id="htmlRead" v-if="view.origin">{{view.origin?view.origin:''}}</span>
          <span class="time" id="ivs_date">{{view.displayDate?view.displayDate: ''}}</span>
        </div>
        <div class="label-box">
          <div id="ivs_player" v-if="view.txt"></div>
        </div>
      </div>  
    <!-- 语音播放器 -->
      <div class="art-txt Article_content">
        <div id="ivs_content">
            <!-- 视频播框  -->
            <!-- path存得是id，name存得是url -->
            <div id="summary" v-if="view.summary">
                {{view.summary?view.summary:''}}
            </div>
            <div class="content" id="" data-pswp-uid="1">
              <!-- <div id="Zoom">
                  {{view.txt}}view.txt
              </div> -->
              <div v-if="hasVideo">
                <template v-for="(item, index) in videoList" >
                  <p :key="index">
                    <video :src="item" controls="controls" style="margin: 0 auto;" >
                    您的浏览器不支持 video 标签。
                    </video>
                  </p>
                </template>
              </div>
              <div id="Zoom" class="ql-editor ql-snow" v-html="view.txt">
              </div>  
            </div>
        </div>
        <div class="art-bot">
            <span v-if="view.author">作者：{{view.author}}</span><br>
            <span v-if="view.reporter">记者：{{view.reporter}}</span><br>
            <span v-if="view.editor">编辑：{{view.editor}}</span>
        </div>
      </div>
    </div>
    <bottom @envChange="envChange"/>
  </div>
</div>  
</template>

<script>
import top from './top'
import bstop from './widget/bstop'
import bottom from './bottom'
import Viewer from 'viewerjs';
export default {
  name: 'index',
  components: {
    bottom,
    bstop,
    top
  },
  props: {
    view: {
      type: Object
    }
  },
  data() {
    return {
      // view: {},
      // videoParan: document.querySelector("#videoParam").getAttribute("videoList")|| '',
      videoList: [],
      origin: '',
      hasVideo: false,
      showBsTop: false,
      slidesSm: [
        {
          // image: require('@/assets/img/share/shareBackgroud.png')
          image: 'https://assets.shmedia.tech/share/backgroundImages/shareBackgroud.png'
        }
      ]
    }
  },
  mounted() {
    this.getView()
  },
  methods: {
    // Viewer
    getp() {
     setTimeout(() => {
        new Viewer(document.getElementById('Zoom'), {
          toolbar: false,
          title: true,
          navbar: false,
          fullscreen: true,
        });
     }, 1000);
    },
    // 详情
    getView() {
      if(this.view !== {}) {
        this.view.origin = this.view.origin || this.site.siteName
        document.getElementsByTagName("title")[0].innerText = this.view.title
        this.getp()
      }
      // 宝山头部轮转图
      if(this.site.appAnUrl.indexOf("baoshan") > -1) {
        this.$nextTick(() => {
          this.showBsTop = true
        })
      }
      // if(this.videoParan) {
      //   this.videoParan.split(',').forEach(e =>{
      //     if(e) {
      //       this.videoList.push(e)
      //     }
      //   })
      //   this.hasVideo = true
      // }
      // const data = {
      //   id: this.obj.content_id
      // }
      // this.post(this.apiUrl.content, data).then((response) => {
      //    this.view = response.data.data || {}
      //    this.view.origin = this.view.origin || this.site.siteName
      //    document.getElementsByTagName("title")[0].innerText = this.view.title
      //    this.getp()
      // })
    },
    envChange(e) {
      this.$emit("envChange", e)
    }
  }
}
</script>
<style>
@import '../../node_modules/viewerjs/dist/viewer.css';
@import 'https://assets.shmedia.tech/css/iconfont.css';
@import 'https://assets.shmedia.tech/css/styleh5.css';
</style>
<style>

    .copy {
        text-align: center;
    }
    .copy span {
        font-size: 0.38rem;
        color: #999;
        display: inline-block;
        position: relative;
    }
    .copy span:after,
    .copy span:before {
        content: "";
        display: block;
        width: 30px;
        height: 1px;
        border-top: 1px solid #eee;
        position: absolute;
        top: 50%;
    }
    .copy span:after {
        right: -35px
    }
    .copy span:before {
        left: -35px;
    }
    /*7/18*/
    .iPlay{
        display: inline-table;
        position: relative;
    }
    .iPlay .jp-video-play{
        display: block;
        position: absolute;
        top: 30%;
        height: 90px;
    }
    .iPlay img{
        border-radius: 5px;
        width: 100%;
    }
    #ivs_player{
        width: 100%;
    }
    #summary {
        background: #f1f1f1;
        line-height: 30px;
        padding: 18px 15px;
        margin-bottom: 20px;
        color: #000;
        border-radius: 15px;
    }
    #htmlRead {
      padding-right: 10px;
    }
</style>